module.exports = __webpack_public_path__ + "media/impact-3.57e2d34f.webm";